import SmoothScroll from 'smooth-scroll';
import $ from 'jquery';
import 'slick-carousel';

var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
});

$('.hero__main__slider').slick({
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  speed: 800,
  fade: true,
  cssEase: 'linear'
});

// observer
function ovserver() {
  const target = document.querySelectorAll('.observe-object');
  const menu = document.getElementById('menu');
  const link = document.querySelectorAll('.menu__link');
  const options = {
    root: null,
    rootMargin: "-50% 0px",
    threshold: 0
  };
  const observer = new IntersectionObserver(menuControl, options)

  target.forEach(e => {
    observer.observe(e);
  });

  function menuControl(entries) {
    entries.forEach(entry => {
      if(entry.target.id == 'about' && entry.isIntersecting || entry.target.id == 'advance' && entry.isIntersecting || entry.target.id == 'gallery' && entry.isIntersecting) {
        menu.classList.add('visible');

        if(entry.target.id == "about") {
          link.forEach(e => {
            e.classList.remove('active');
          });

          document.querySelector('.menu__link--support').classList.add('active');
        }

        if(entry.target.id == "advance") {
          link.forEach(e => {
            e.classList.remove('active');
          });

          document.querySelector('.menu__link--advance').classList.add('active');
        }

        if(entry.target.id == "gallery") {
          link.forEach(e => {
            e.classList.remove('active');
          });

          document.querySelector('.menu__link--gallery').classList.add('active');
        }
      } else if(entry.target.id == 'hero' && entry.isIntersecting || entry.target.id == 'footer' && entry.isIntersecting) {
        menu.classList.remove('visible')
      }
    })
  }
}

ovserver()